module.exports = __webpack_public_path__ + "img/decor_button_diameter.2014f90e.png";